var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenchmarksOlderthan5Years(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e32329;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    className: "cls-1",
    d: "M10.47,8.51c.38,0,.68-.31.68-.68h0V3.07c0-.38-.31-.68-.68-.68-.38,0-.68.31-.68.68v4.75c0,.38.31.68.68.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    className: "cls-1",
    d: "M21.14,8.51c.38,0,.68-.31.68-.68V3.07c0-.38-.31-.68-.68-.68s-.68.31-.68.68v4.75c0,.38.31.68.68.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    className: "cls-1",
    d: "M4.48,24.6c0,1.93,1.56,3.5,3.49,3.5h15.66c1.93,0,3.49-1.57,3.49-3.5v-12H4.48v12ZM19.79,15.47c0-.41.33-.75.75-.75,0,0,0,0,0,0h3.16c.41,0,.75.33.75.75h0v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.34-.75-.75h0v-2.66ZM19.79,21.45c0-.41.33-.75.75-.75h3.16c.41,0,.75.33.75.75h0v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.34-.75-.75h0v-2.66ZM13.48,15.51c0-.41.34-.75.75-.75h3.16c.41,0,.75.34.75.75v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.34-.75-.75v-2.66ZM13.48,21.44c0-.41.34-.75.75-.75h3.16c.41,0,.75.33.75.75,0,0,0,0,0,0v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.34-.75-.75v-2.66ZM7.16,15.51c0-.41.34-.75.75-.75h3.16c.41,0,.75.34.75.75v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.33-.75-.75,0,0,0,0,0,0v-2.66ZM7.16,21.44c0-.41.34-.75.75-.75h3.16c.41,0,.75.34.75.75h0v2.66c0,.41-.34.75-.75.75h-3.16c-.41,0-.75-.34-.75-.75v-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    className: "cls-1",
    d: "M27.13,8.94c0-1.93-1.57-3.5-3.5-3.5h-1.18v2.38c0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31v-2.38h-8.06v2.38c0,.72-.59,1.31-1.31,1.31-.72,0-1.31-.59-1.31-1.31h0v-2.38h-1.18c-1.93,0-3.5,1.56-3.5,3.5v2.68h22.65v-2.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarksOlderthan5Years);
export default __webpack_public_path__ + "static/media/Benchmarks Older than 5 Years.b271a41655979b801421339ae1ff10ef.svg";
export { ForwardRef as ReactComponent };